import { Route } from '@angular/router';
import { provideStates } from '@ngxs/store';
import { AviaApiService } from './services/avia-api.service';
import { AviaSearchFormService } from './services/avia-search-form.service';
import { AviaState } from './state/avia.state';

export const aviaPageRouteConfig: Route = {
  path: 'avia',
  loadComponent: () => import('./avia-page.component').then((c) => c.AviaPageComponent),
  providers: [provideStates([AviaState]), AviaApiService, AviaSearchFormService]
};
